import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { NbToastrService } from '@nebular/theme';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { StyleComponent } from '../domains/components/style/style.component';
import { SPECIFICINSTALATIONDATA_HEADERS } from './specifiInstalationData-settings';
import { IspecificInstalationData } from 'projects/pplus/src/lib/interfaces/interfaces';
import { RowDataService } from 'projects/pplus/src/lib/components/split-form/services/row-data.service';
import { AgCheckboxComponent } from 'projects/pplus/src/lib/components/ag-grid/ag-checkbox/ag-checkbox.component';

@Component({
  selector: 'app-specificInstalationData',
  templateUrl: './specificInstalationData.component.html',
  styleUrls: ['./specificInstalationData.component.scss']
})
export class SpecificInstalationDataComponent implements OnInit {

  @ViewChild('splitContent', { static: false}) splitContent;
  @ViewChild('agGrid', { read: ElementRef , static: false}) agGridNativeElement: ElementRef;

  splitOptions = {
    open: false,
    direction: 'horizontal',
    contentSize: 100,
    formSize: 0,
  };

  items = [
    { title: 'm1'},
    { title: 'm2'}
  ];

  contextMenu = {
    X: 0,
    Y: 0,
    state: false,
  };

  row: IspecificInstalationData = {
    Id: null,
    Id_country: null,
    caracteristicName: null,
  };

  TitleForm = 'Detalles';
  gridApi;
  gridColumnApi;
  detailsButton = "Detalles Generales";
  data;
  gridOptions: GridOptions;
  columnDefs = SPECIFICINSTALATIONDATA_HEADERS;
  pageX;
  pageY;

  formStatus: boolean;

  constructor(//private plantGroupService: PlantGroupService,
              private toastr: NbToastrService,
              private dataRow: RowDataService,
              private breakPointObserver: BreakpointObserver) {
    this.gridOptions = <GridOptions>{};
    this.gridOptions.paginationPageSize = 20;
    this.gridOptions.rowDragManaged = true;
    this.gridOptions.enableSorting = true;
    this.gridOptions.enableFilter = true;
    this.gridOptions.floatingFilter = true;
    this.gridOptions.frameworkComponents = {
      checkBoxComponent: AgCheckboxComponent,
      styleComponent: StyleComponent
    };
    this.gridOptions.overlayLoadingTemplate = '<span class="ag-overlay-loading-center"><img src="assets/loader.svg" alt="loader" class="img-fluid" style="width:40px;height:40px;"></span>';
    this.gridOptions.rowSelection = 'multiple';

  }

  ngAfterViewInit() {}

  ngOnInit() {
    /*this.dataRow.currentRowData.subscribe(row => this.row = <IEntityPlant>row);
    this.plantGroupService.getAllPlantGroup()
    .subscribe( (res) => {
      console.log(res);
      this.data = res;
      console.log(this.data);
    });*/
  }

  onGridRowClicked(row) {
    this.row = {
      Id: row.data.Id,
      Id_country: row.data.Id_country,
      caracteristicName: row.data.caracteristicName,
    };
    this.dataRow.updateRowData(this.row);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

    params.api.sizeColumnsToFit();

    window.addEventListener("resize", function() {
      setTimeout(function() {
        params.api.sizeColumnsToFit();
      });
    });

    this.agGridNativeElement.nativeElement.addEventListener('contextmenu', function ($event: any) {
      $event.preventDefault();
    });
  }

  onCellContextMenu($event) {
    $event.event.preventDefault();
    const e = $event.event;
    // console.log($event);
    // console.log('X: ' + $event.event.clientX + '  Y:' + $event.event.clientY);

    let posx = 0;
    let posy = 0;

    if (e.pageX || e.pageY) {
      posx = e.pageX;
      posy = e.pageY;
    } else if (e.clientX || e.clientY) {
      posx = e.clientX + document.body.scrollLeft +
      document.documentElement.scrollLeft;
      posy = e.clientY + document.body.scrollTop +
      document.documentElement.scrollTop;
    }

    this.contextMenu = {
      X: posx,
      Y: posy,
      state: true
    };

    this.row = {
      Id: $event.data.Id,
      Id_country: $event.data.Id_country,
      caracteristicName: $event.data.caracteristicName,
    };
  }

  rowDoubleClicked($event){
    this.row = {
      Id: $event.data.Id,
      Id_country: $event.data.Id_country,
      caracteristicName: $event.data.caracteristicName,
    };
    this.openSplit();
  }

  openSplit() {
    this.breakPointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe( res => {
      if (res.matches) {
        this.splitOptions = {
          open: true,
          direction: 'horizontal',
          contentSize: 0,
          formSize: 100,
        };
      } else {
        this.splitOptions = {
          open: true,
          direction: 'horizontal',
          contentSize: 70,
          formSize: 30,
        };
      }
    });
  }

  showToast(icon, status, title , msg) {
    this.toastr.show(title, msg , { icon, status });
  }

  readSplitOptions(event) {
    this.splitOptions = event.opt;
    if (event.mode === 'create') {
      this.formStatus = true;
    } else {
      this.formStatus = false;
    }
  }

  //NO SE DEBERÍA IR A BD PARA ACTUALIZAR
  updateData(data) {
   /* switch (data.Type) {
      case 'delete':
        this.data.forEach( element => {
          if (element.plantId === data.plantId){
            this.data.splice(this.data.indexOf(element), 1);
            this.gridApi.setRowData(this.data);
          }
        });
        break;
      case 'create':
        this.plantGroupService.getAllPlantGroup()
        .subscribe( (res) => {
          this.data = res;
        });
    }*/
  }

  quickSearch(data: string) {
    this.gridApi.setQuickFilter(data);
  }

  resizeGrid(event) {
    this.gridApi.sizeColumnsToFit();
  }


}
